module.exports = __webpack_public_path__ + "img/ajoure.2283292.svg";